// import { useContext } from 'react';
// import { StoreContext } from './storeProviders';

// export const useStores = () => {
//   return useContext(StoreContext);
// };

import { useContext } from 'react';
import { RootStore } from '../store';
import { StoreContext } from './store-providers';

export const useStores = (): RootStore => useContext(StoreContext);
